import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './simple-modal.component.html',
  styleUrls: ['./simple-modal.component.less'],
})
export class SimpleModalComponent implements OnInit {
  @Input() message: string;
  @Input() hasCancellationButton: boolean;
  @Input() width = 20;
  @Input() confirmButtonLabel = 'Confirm';
  @Input() cancelButtonLabel = 'Cancel';

  constructor(private modal: NgbActiveModal) {}

  ngOnInit(): void {}

  closePopup(actionConfirmed = false) {
    this.modal.close(actionConfirmed);
  }
}
